export default __webpack_public_path__ + "a15d4766db2330e13b0347b339100dc9.png";